import React from 'react';

interface Badge {
  type: string;
  text: string;
  style: React.CSSProperties;
}

interface PlayerBadgesProps {
  badges: Badge[];
  isMobile: boolean;
  isCompact: boolean;
}

export const PlayerBadges: React.FC<PlayerBadgesProps> = ({
  badges,
  isMobile,
  isCompact
}) => {
  if (badges.length === 0) return null;

  const isDesktop = !isMobile && !isCompact;

  return (
    <div style={{
      display: 'flex',
      gap: isDesktop ? '3px' : (isMobile || isCompact ? '3px' : '4px'),
      flexWrap: 'wrap',
      alignItems: 'center',
      marginTop: isDesktop ? '0' : (isMobile || isCompact ? '4px' : '6px'),
    }}>
      {badges.map((badge, index) => (
        <div
          key={index}
          style={{
            display: 'inline-block',
            padding: isDesktop ? '1px 4px' : (isMobile || isCompact ? '2px 6px' : '2px 8px'),
            borderRadius: isDesktop ? '3px' : '6px',
            fontWeight: 700,
            fontSize: isDesktop ? '9px' : (isMobile || isCompact ? '10px' : '11px'),
            letterSpacing: '0.04em',
            ...badge.style
          }}
        >
          {badge.text}
        </div>
      ))}
    </div>
  );
};
